import Cookies from 'js-cookie'


export function getToken(TokenKey) {
  return Cookies.get(TokenKey)
}

export function setToken(TokenKey,token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken(TokenKey) {
  return Cookies.remove(TokenKey)
}

export function getLocalStorage(STORAGE_KEY) {
  return window.localStorage.getItem(STORAGE_KEY)
}

export function saveLocalStorage(STORAGE_KEY, items) {
  return window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
}

export function removeLocalStorage(STORAGE_KEY) {
  return window.localStorage.removeItem(STORAGE_KEY)
}


export function clearLocalStorage() {
  return  window.localStorage.clear()
}
